import {
  IContextualMenuItemProps,
  TooltipHost,
  CommandBar,
  IButtonProps,
  ContextualMenuItem,
  ITooltipHostStyles,
  ITooltipProps,
  TooltipDelay,
  DirectionalHint,
  Modal,
  getTheme,
  IIconProps,
  mergeStyleSets,
  FontWeights,
  IButtonStyles,
  IconButton,
  Text,
  FontIcon,
} from "@fluentui/react";
import ResourceDetailM365 from "./resource-detailm365";
import ResourceDetailSPO from "./resource-detailspo";
import {
  checkResourceCompliance,
  drawTextInCanvas,
  generateRandomString,
  getFormattedDate,
  getResourceLink,
  isWithinLast90Days,
} from "../utils";
import { resource } from "../objects/resource";
import { createRoot } from "react-dom/client";
import ResourceNavlink from "./resource-navlink";
import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { apiScopes, msalConfig } from "../authConfig";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { ComplianceField } from "./compliance-field";
import { ChangeType, SensitivityLabel, ComplianceRule } from "../enums";
import Swal from "sweetalert2";
import { renderToStaticMarkup } from "react-dom/server";
import {
  deletem365Group,
  deleteSPOSite,
  requestPermissionReport,
  requestArchiveSite,
  getDepartmentByLevel,
  updateWorkspaceDepartment,
} from "../services/resource-manager";
import { errorsTypes } from "../errorTypes";
import StatusCode from "status-code-enum";
import { toast } from "react-toastify";
import { ExpirationDateField } from "./date-field";
import { archivedSite } from "../objects/archivedSite";
import {
  extendResourceLease,
  updateSensitivityLabel,
} from "../services/resource-manager";
import { useEffect, useReducer, useState } from "react";
import { useId, useBoolean } from "@fluentui/react-hooks";
import { DepartmentSelector } from "./department-selector";
import { department } from "../objects/department";
import { useNavigate } from "react-router-dom";
interface ownedResources {
  ownedResources: Array<resource>;
  resourceType: string;
  refreshDatasetFunction: (
    resourceID: string,
    changeType: ChangeType,
    value: any,
  ) => void;
}
interface resourceDetailProps {
  ownedResource: resource;
  baseTabId: string;
  refreshDatasetFunction: (
    resourceID: string,
    changeType: ChangeType,
    value: any,
  ) => void;
}

/**
 * Grid component, displays the list of resources on an accordion table
 */
export function ResourceGrid(props: ownedResources) {
  const navigate = useNavigate();
  useEffect(() => {
    console.log("Component mounted - runs only once");
    instance
      .acquireTokenSilent(accessTokenRequest)
      .then(async (accessTokenResponse) => {
        let departmentResultLvl4 = await getDepartmentByLevel(
          accessTokenResponse.accessToken,
          4,
        );
        let departmentResultLvl3 = await getDepartmentByLevel(
          accessTokenResponse.accessToken,
          3,
        );
        setDefaultDepartmentList([
          ...departmentResultLvl3,
          ...departmentResultLvl4,
        ]);
      });
  }, []);
  const [departmentState, setDepartmentState] = useState<{
    departmentCode: string;
    resourceId: string;
    isM365: boolean;
    resourceName: string;
  }>({
    departmentCode: "",
    resourceId: "",
    isM365: false,
    resourceName: "",
  });

  const updateDepartment = async (
    newDepartmentCode: string,
    newResourceId: string,
    isConnected: boolean,
  ) => {
    Swal.showLoading();
    let toastLeaseRenewId: any = null;

    try {
      const accessTokenResponse =
        await instance.acquireTokenSilent(accessTokenRequest);
      toastLeaseRenewId = toast.loading(`Updating Department`);

      try {
        const requestReportResult = await updateWorkspaceDepartment(
          accessTokenResponse.accessToken,
          newResourceId,
          newDepartmentCode,
          isConnected,
        );

        // If we reach here, the operation was successful
        props.refreshDatasetFunction(
          newResourceId,
          ChangeType.UpdateDepartment,
          requestReportResult as department,
        );

        forceUpdate();

        toast.update(toastLeaseRenewId, {
          render: "Operation Complete",
          type: "success",
          isLoading: false,
          autoClose: 8000,
        });
        hideModal();
      } catch (apiError: any) {
        // updateWorkspaceDepartment failed - don't refresh data
        console.error("API Error:", apiError);

        toast.update(toastLeaseRenewId, {
          render: `Failed to update department: ${apiError.message || "Unknown error"}`,
          type: "error",
          isLoading: false,
          autoClose: 8000,
        });

        Swal.fire({
          titleText: "Update Failed",
          text: `Unable to update department: ${apiError.message || "An error occurred"}`,
          icon: "error",
        });
      }

      Swal.close();
    } catch (error: any) {
      Swal.close();

      // Update toast with error if it exists
      if (toastLeaseRenewId) {
        toast.update(toastLeaseRenewId, {
          render: "Update failed due to an unexpected error",
          type: "error",
          isLoading: false,
          autoClose: 8000,
        });
      }

      if (error instanceof InteractionRequiredAuthError) {
        Swal.fire({
          titleText: errorsTypes.sessionExpired.errorTitle,
          text: errorsTypes.sessionExpired.errorSubtitle,
          icon: "error",
          willClose: () => {
            instance.acquireTokenRedirect(accessTokenRequest);
          },
        });
      } else {
        // Handle other types of errors
        Swal.fire({
          titleText: "Error",
          text: `An unexpected error occurred: ${error.message || error}`,
          icon: "error",
        });
      }

      console.error("Error in updateDepartment:", error);
    }
  };
  const departmenTtooltipProps: ITooltipProps = {
    onRenderContent: () => (
      <div style={{ margin: 10 }}>
        <Text variant="mediumPlus" block style={{ fontWeight: "bold" }}>
          Click here to edit
        </Text>
      </div>
    ),
  };
  const titleId = useId("title");
  const [defaultDepartmentList, setDefaultDepartmentList] = useState<
    Array<department>
  >([]);
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const { instance, accounts } = useMsal();
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const accessTokenRequest = {
    scopes: apiScopes.resourceManagementScopes,
    account: accounts[0],
  };
  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "inline-block" },
  };
  const cancelIcon: IIconProps = { iconName: "Cancel" };

  const theme = getTheme();
  const iconButtonStyles: Partial<IButtonStyles> = {
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "2px",
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
    header: [
      theme.fonts.xLarge,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    heading: {
      color: theme.palette.neutralPrimary,
      fontWeight: FontWeights.semibold,
      fontSize: "inherit",
      margin: "0",
    },
    body: {
      flex: "4 4 auto",
      minWidth: "500px",
      padding: "0 24px 24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
  });

  function handleTableScroll(e: React.UIEvent<HTMLDivElement>) {
    setIsScrolled(e.currentTarget.scrollTop > 0);
  }
  function getExtClassificationToolTip(setupToolFlag: string): ITooltipProps {
    const tooltipProps: ITooltipProps = {
      onRenderContent: () => (
        <div>
          <p>
            This workspace is managed by{" "}
            {setupToolFlag === "DMS"
              ? " the Disclosure Management System "
              : " Intel Foundy Services "}
            <a
              href={
                setupToolFlag === "DMS"
                  ? "https://wiki.ith.intel.com/display/disclosures/Disclosure+Management+System+Home"
                  : "https://circuit.intel.com/content/it/it-support/topic-pages/others/ifs-intel-foundry-services-portal.html"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              Click for more information
            </a>
          </p>
        </div>
      ),
    };
    return tooltipProps;
  }

  async function requestPermissionsReport(currentResource: resource) {
    let htmlDialogContent = (
      <div>
        <h4 style={{ color: "#0054ae" }}>SharePoint Site Permissions Report</h4>
        <br></br>
        <p>
          This application generates a detailed report of how permissions are
          distributed across your SharePoint Online site. The report will
          include permissions for lists, individual items, and individual files
          shared using unique links.
        </p>
        <p>
          If you accept, the application will process the report, upload the
          data as a file, and email you the link to access it. The link will be
          active for 24 hours.
        </p>
      </div>
    );
    Swal.fire({
      html: renderToStaticMarkup(htmlDialogContent),
      showCancelButton: true,
      confirmButtonText: "Request",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.close();
        const toastRequestID = toast.loading("Requesting Report");
        instance
          .acquireTokenSilent(accessTokenRequest)
          .then(async (accessTokenResponse) => {
            let requestReportResult = await requestPermissionReport(
              accessTokenResponse.accessToken,
              currentResource.isGroupConnected,
              currentResource.isGroupConnected
                ? currentResource.azureAdId
                : currentResource.siteUrl,
            );
            if (requestReportResult === StatusCode.SuccessNoContent) {
              toast.update(toastRequestID, {
                render: `The permission report for ${currentResource.siteUrl} was successfully requested`,
                type: "success",
                isLoading: false,
                autoClose: 8000,
              });
            } else {
              toast.update(toastRequestID, {
                render: errorsTypes.internalServerError.errorSubtitle,
                type: "error",
                isLoading: false,
                autoClose: 8000,
              });
            }
          });
      } else if (result.isDenied) {
        Swal.close();
      }
    });
  }

  async function ArchiveResources(currentResource: resource) {
    const htmlDialogContent = (
      <div>
        <h4 style={{ color: "#0054ae" }}>Archive this workspace</h4>
        <p>
          This functionality allows you to preserve your workspace while pausing
          user access. You can reactivate it at any time and the process will
          take up to 24 hours to complete.
        </p>
        <p>Please select the desired duration of archival:</p>
        <select
          id="archiveDuration"
          title="archiveDuration"
          style={{
            backgroundColor: "#ddddddff",
            border: "1px solid #ddddddff",
            width: "100px",
            padding: "7px",
            fontSize: "16px",
            borderRadius: "6px",
          }}
        >
          <option value="1">1 year</option>
          <option value="3">3 years</option>
          <option value="5">5 years</option>
        </select>
        <br />
        <a
          href="https://intel.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3Dc174d5c41beeda101e4a0e13604bcb27%26sysparm_preview%3Dtrue%26sysparm_domain_restore%3Dfalse%26sysparm_stack%3Dno"
          style={{
            display: "inline-block",
            marginTop: "10px",
            color: "#406d9dff",
            fontSize: "14px",
            textDecoration: "underline",
            textDecorationColor: "#8096afff",
          }}
        >
          Do you require a different duration?
        </a>
      </div>
    );

    Swal.fire({
      html: renderToStaticMarkup(htmlDialogContent),
      showCancelButton: true,
      confirmButtonText: "Next",
    }).then((result) => {
      if (result.isConfirmed) {
        const archiveDurationElement = document.getElementById(
          "archiveDuration",
        ) as HTMLSelectElement | null;
        const archiveDuration = archiveDurationElement?.value ?? "1";
        const archivedUntil = new Date();
        archivedUntil.setFullYear(
          archivedUntil.getFullYear() + parseInt(archiveDuration),
        );

        Swal.close();

        const secondDialogContent = (
          <div>
            <h4 style={{ color: "#0054ae" }}>Archive this workspace</h4>
            <br />
            <p>Is this workspace required for retention purposes?</p>
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginBottom: "15px",
                justifyContent: "center",
              }}
            >
              <label>
                <input
                  type="radio"
                  name="retention"
                  value="yes"
                  style={{ marginRight: "8px" }}
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="retention"
                  checked={true}
                  value="no"
                  style={{ marginRight: "8px" }}
                />
                No
              </label>
            </div>
            <div>
              <textarea
                id="justification"
                placeholder="Provide business justification..."
                required
                style={{
                  width: "100%",
                  height: "80px",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                  color: "#666",
                  resize: "none",
                }}
              />
            </div>
          </div>
        );

        Swal.fire({
          html: renderToStaticMarkup(secondDialogContent),
          showCancelButton: true,
          confirmButtonText: "Archive",
        }).then((result) => {
          if (result.isConfirmed) {
            const justificationElement = document.getElementById(
              "justification",
            ) as HTMLTextAreaElement | null;
            const justification = justificationElement?.value ?? "";

            Swal.close();
            const toastRequestID = toast.loading("Archiving the workspace...");

            instance
              .acquireTokenSilent(accessTokenRequest)
              .then(async (accessTokenResponse) => {
                const accessToken = accessTokenResponse.accessToken;

                const archiveRequest = new archivedSite();
                archiveRequest.id = currentResource.siteId;
                archiveRequest.archivedUntil = archivedUntil;
                archiveRequest.businessJustification = justification;
                archiveRequest.requiredForRetention =
                  document.querySelector<HTMLInputElement>(
                    'input[name="retention"]:checked',
                  )?.value ?? "no";
                archiveRequest.isConnected = currentResource.isGroupConnected
                  ? "Y"
                  : "N";
                archiveRequest.m365GroupId = currentResource.isGroupConnected
                  ? currentResource.azureAdId
                  : null;

                try {
                  const statusCode = await requestArchiveSite(
                    accessToken,
                    archiveRequest,
                  );

                  if (statusCode === StatusCode.SuccessNoContent) {
                    toast.update(toastRequestID, {
                      render: `The workspace has been successfully archived. It will be retained until ${getFormattedDate(archivedUntil,true)}.`,
                      type: "success",
                      isLoading: false,
                      autoClose: 8000,
                    });
                    navigate("/archived");
                  } else {
                    toast.update(toastRequestID, {
                      render: errorsTypes.internalServerError.errorSubtitle,
                      type: "error",
                      isLoading: false,
                      autoClose: 8000,
                    });
                  }
                } catch (error) {
                  toast.update(toastRequestID, {
                    render: "An error occurred while archiving the workspace.",
                    type: "error",
                    isLoading: false,
                    autoClose: 8000,
                  });
                }
              });
          }
        });
      }
    });
  }

  async function encourageArchive(
    props: resourceDetailProps,
    currentIndex: number,
    resourceType: string,
  ) {
    const htmlDialogContent = (
      <div>
        <p>
          According to our records, this workspace has not been active in the
          past 6 months.
        </p>
        <p>
          Please archive or delete the workspace if it is no longer in use.
          Keeping only active content improves performance and compliance.
        </p>
      </div>
    );

    if (!isWithinLast90Days(props.ownedResource.lastUpdatedFormatted)) {
      Swal.fire({
        title:
          '<span style="color:#0054ae; font-size:24px; font-weight:normal; display:block; margin-bottom:4px;">Workspace Inactivity</span>',
        html: renderToStaticMarkup(htmlDialogContent),
        showCancelButton: true,
        showDenyButton: true,
        showCloseButton: true,
        confirmButtonText: "Delete",
        denyButtonText: "Archive",
        cancelButtonText: "Continue",
        confirmButtonColor: "#CE0000",
        denyButtonColor: "#3085d6",
        allowOutsideClick: false,
        didOpen: () => {
          const closeBtn = document.querySelector(
            ".swal2-close",
          ) as HTMLElement;
          if (closeBtn) {
            closeBtn.style.fontSize = "1.8rem";
            closeBtn.style.position = "absolute";
            closeBtn.style.top = "4px";
            closeBtn.style.transform = "translateY(-8px)";
            closeBtn.style.right = "12px";
            closeBtn.style.color = "#677f99ff";
          }

          const title = document.querySelector(".swal2-title") as HTMLElement;
          if (title) {
            title.style.marginBottom = "4px";
          }

          const actions = document.querySelector(
            ".swal2-actions",
          ) as HTMLElement;
          if (actions) {
            actions.style.marginTop = "8px";
          }

          const popup = document.querySelector(".swal2-popup") as HTMLElement;
          if (popup) {
            popup.style.paddingTop = "4px";
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          redirectoDeletePage(props.ownedResource, currentIndex);
        } else if (result.isDenied) {
          ArchiveResources(props.ownedResource);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          validateExternalResourceLease(props, currentIndex, resourceType);
        }
      });
    } else {
      validateExternalResourceLease(props, currentIndex, resourceType);
    }
  }

  async function redirectoDeletePage(
    currentResource: resource,
    currentIndex: number,
  ) {
    let confirmationCode = generateRandomString(6);
    let htmlDialogContent = (
      <div>
        <p>
          You are about to delete the '{currentResource.displayName}' site. This
          will delete all SharePoint content in the site. Please backup any
          files or other content before proceeding. Do you want to continue?
        </p>
        <br></br>
        <div className="container card">
          <canvas id="secretCodeCanvas" width="auto" height="100"></canvas>
        </div>
      </div>
    );

    const { value: paramConfCode } = await Swal.fire({
      title: "Delete this resource",
      input: "text",
      inputLabel: "Enter the text displayed above:",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      allowEnterKey: false,
      allowOutsideClick: false,
      inputValidator: (value) => {
        if (!value) return "Please enter the confirmation code";
        else if (value !== confirmationCode)
          return "The confirmation code is incorrect";
        else return null;
      },
      confirmButtonText: "Delete",
      confirmButtonColor: "#CE0000",
      inputPlaceholder: "Enter the code here",
      html: renderToStaticMarkup(htmlDialogContent),
      didOpen: () => {
        drawTextInCanvas("secretCodeCanvas", confirmationCode);
      },
    });
    if (paramConfCode) {
      if (paramConfCode === confirmationCode) {
        const toastDeleteId = toast.loading(
          `Deleting the resouce: ${currentResource.displayName} , this might take 30 seconds or more`,
        );
        instance
          .acquireTokenSilent(accessTokenRequest)
          .then(async (accessTokenResponse) => {
            let deleteResult: number = 0;

            props.refreshDatasetFunction(
              currentResource.isGroupConnected
                ? currentResource.azureAdId
                : currentResource.siteUrl,
              currentResource.isGroupConnected
                ? ChangeType.DeleteGroup
                : ChangeType.DeleteSite,
              null,
            );
            try {
              let collapseButtonId =
                "btn-expandResource" + props.resourceType + currentIndex;
              let buttonElement = document.getElementById(collapseButtonId);
              let isTabExpanded = buttonElement?.getAttribute("aria-expanded");
              if (isTabExpanded === "true") {
                buttonElement?.click();
              }
            } catch {
              console.log("Could not trigger tab collapse");
            }

            if (currentResource.isGroupConnected) {
              deleteResult = await deletem365Group(
                accessTokenResponse.accessToken,
                currentResource.azureAdId,
              );
            } else {
              deleteResult = await deleteSPOSite(
                accessTokenResponse.accessToken,
                currentResource.siteUrl,
              );
            }

            if (deleteResult === StatusCode.SuccessNoContent) {
              toast.update(toastDeleteId, {
                render: `Resource succesfully deleted: ${currentResource.displayName}`,
                type: "success",
                isLoading: false,
                autoClose: 8000,
              });
            } else {
              toast.update(toastDeleteId, {
                render: errorsTypes.internalServerError.errorSubtitle,
                type: "error",
                isLoading: false,
                autoClose: 8000,
              });
            }
          })
          .catch((error) => {
            if (error instanceof InteractionRequiredAuthError) {
              toast.update(toastDeleteId, {
                render: `We encountered a problem while deleting: ${currentResource.displayName}. Please try again later or contact support. No data was deleted.`,
                type: "error",
                isLoading: false,
                autoClose: 8000,
              });
              instance.acquireTokenRedirect(accessTokenRequest);
            }
            console.log(error);
          });
      }
    }
  }

  function handleResourceDetailLoad(
    buttonElementID: string,
    containerID: string,
    currentResource: resource,
    currentArrayIndex: number,
  ) {
    props.ownedResources.forEach((element) => {
      element.compliance = checkResourceCompliance(element);
    });
    const currentResourceDetailButton: HTMLElement | null =
      document.getElementById(buttonElementID);
    const msalInstance = new PublicClientApplication(msalConfig);
    if (!currentResourceDetailButton!.classList.contains("collapsed")) {
      const currentResourceDetailNode = document.getElementById(containerID)!;
      const root = createRoot(currentResourceDetailNode);
      if (currentResource.resourceType === "SPO") {
        root.render(
          <MsalProvider instance={msalInstance}>
            <ResourceDetailSPO
              ownedResource={currentResource}
              baseTabId={"tab-" + props.resourceType + currentArrayIndex}
              refreshDatasetFunction={props.refreshDatasetFunction}
              tabIndex={currentArrayIndex}
            />
          </MsalProvider>,
        );
      } else {
        root.render(
          <MsalProvider instance={msalInstance}>
            <ResourceDetailM365
              ownedResource={currentResource}
              baseTabId={"tab-" + props.resourceType + currentArrayIndex}
              refreshDatasetFunction={props.refreshDatasetFunction}
              tabIndex={currentArrayIndex}
            />
          </MsalProvider>,
        );
      }
    }
  }

  const CustomMenuItem: React.FunctionComponent<IContextualMenuItemProps> = (
    props,
  ) => {
    return <ContextualMenuItem {...props} />;
  };

  const overflowProps: IButtonProps = {
    menuProps: {
      contextualMenuItemAs: CustomMenuItem,
      // Styles are passed through to menu items here

      items: [], // CommandBar will determine items rendered in overflow
      isBeakVisible: true,
      beakWidth: 20,
    },
  };

  async function validateExternalResourceLease(
    props: resourceDetailProps,
    currentIndex: number,
    resourceType: string,
  ): Promise<void> {
    Swal.fire({
      title: "Extending lease...",
      didOpen: () => {
        Swal.showLoading();
        instance
          .acquireTokenSilent(accessTokenRequest)
          .then(async (accessTokenResponse) => {
            if (
              props.ownedResource.sensitivityLabel !==
              (SensitivityLabel.InternalOnly as string)
            ) {
              Swal.fire({
                title: "External Facing Workspace",
                text: "This workspace is external facing, that allows you to collaborate with people outside the intel network. After renewing the lease over this space do you still need it to be external facing?",
                showDenyButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: "Yes, keep the workspace as external",
                denyButtonText: "No, convert to internal",
                cancelButtonText: "Cancel, I'll renew later",
              }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isDenied) {
                  const toastLeaseRenewId = toast.loading(
                    "Updating resource lease",
                  );
                  let sensitivityLabelChgResult = await updateSensitivityLabel(
                    accessTokenResponse.accessToken,
                    props.ownedResource.isGroupConnected
                      ? props.ownedResource.azureAdId
                      : props.ownedResource.siteUrl,
                    props.ownedResource.isGroupConnected,
                    SensitivityLabel.InternalOnly,
                  );
                  let operationResult = await extendResourceLease(
                    accessTokenResponse.accessToken,
                    props.ownedResource.isGroupConnected
                      ? props.ownedResource.azureAdId
                      : encodeURIComponent(props.ownedResource.siteUrl),
                    props.ownedResource.isGroupConnected,
                  );
                  if (
                    operationResult === StatusCode.SuccessOK &&
                    sensitivityLabelChgResult === StatusCode.SuccessOK
                  ) {
                    props.refreshDatasetFunction(
                      props.ownedResource.isGroupConnected
                        ? props.ownedResource.azureAdId
                        : props.ownedResource.siteUrl,
                      ChangeType.UpdateLeaseInternal,
                      null,
                    );

                    let collapseButtonId = props.baseTabId.replace(
                      "tab-",
                      "btn-expandResource",
                    );
                    try {
                      let buttonElement =
                        document.getElementById(collapseButtonId);
                      buttonElement?.click();
                    } catch {
                      console.log("Could not trigger tab collapse");
                    }
                    toast.update(toastLeaseRenewId, {
                      render: "Operation Complete",
                      type: "success",
                      isLoading: false,
                      autoClose: 8000,
                    });
                  } else {
                    toast.update(toastLeaseRenewId, {
                      render: errorsTypes.somethingWentWrong.errorSubtitle,
                      type: "error",
                      isLoading: false,
                      autoClose: 8000,
                    });
                  }
                } else if (result.isConfirmed) {
                  Swal.fire({
                    title: "External Facing Workspace",
                    text: "Your workspace is externally accessible. Please review the list of guest users who currently have access. When you’ve completed your review, click “Confirm Audit” to finalize the process and renew your workspace lease.",
                    showDenyButton: false,
                    showCancelButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "Review my guests",
                    cancelButtonText: "Cancel, I'll renew later",
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      let isAccordionOpen = false;
                      let isGuestsTabOpen = false;
                      let accordionButtonId = `btn-expandResource${resourceType}${currentIndex}`;
                      let guestsTabButtonId = props.baseTabId + "-guests";
                      let guestsButtonElement =
                        document.getElementById(guestsTabButtonId);
                      let accordionButtonElement =
                        document.getElementById(accordionButtonId);
                      if (accordionButtonElement) {
                        isAccordionOpen =
                          accordionButtonElement.classList.length < 3;
                      }
                      if (guestsButtonElement) {
                        isGuestsTabOpen =
                          guestsButtonElement.classList.contains("active");
                      }
                      if (!isAccordionOpen) {
                        try {
                          accordionButtonElement?.click();
                          setTimeout(() => {
                            guestsButtonElement =
                              document.getElementById(guestsTabButtonId);
                            guestsButtonElement?.click();
                          }, 1000);
                        } catch {}
                      } else {
                        guestsButtonElement?.click();
                      }
                    }
                  });
                } else if (result.isDismissed) {
                  Swal.close();
                }
              });
            } else {
              const toastLeaseRenewId = toast.loading(
                "Updating resource lease",
              );

              let operationResult = await extendResourceLease(
                accessTokenResponse.accessToken,
                props.ownedResource.isGroupConnected
                  ? props.ownedResource.azureAdId
                  : encodeURIComponent(props.ownedResource.siteUrl),
                props.ownedResource.isGroupConnected,
              );
              Swal.hideLoading();
              Swal.close();
              if (operationResult === StatusCode.SuccessOK) {
                props.refreshDatasetFunction(
                  props.ownedResource.isGroupConnected
                    ? props.ownedResource.azureAdId
                    : props.ownedResource.siteUrl,
                  ChangeType.UpdateLease,
                  null,
                );
                forceUpdate();
                toast.update(toastLeaseRenewId, {
                  render: "Operation Complete",
                  type: "success",
                  isLoading: false,
                  autoClose: 8000,
                });
              } else {
                toast.update(toastLeaseRenewId, {
                  render: errorsTypes.somethingWentWrong.errorSubtitle,
                  type: "error",
                  isLoading: false,
                  autoClose: 8000,
                });
              }
            }
          })
          .catch((error) => {
            if (error instanceof InteractionRequiredAuthError) {
              toast.error(errorsTypes.somethingWentWrong.errorSubtitle, {
                type: "error",
                isLoading: false,
                autoClose: 8000,
              });
            }
            console.log(error);
          });
      },
    });
  }
  function calculateCompliance(props: resourceDetailProps) {
    if (props.ownedResource.setupToolFlag !== "") {
      return true;
    }
    let twoOwnerEnformentCompliant = true;
    //remainingDays = 0;
    for (
      let index = 0;
      index < props.ownedResource.compliance.length;
      index++
    ) {
      if (
        props.ownedResource.compliance[index].complianceRule ===
          ComplianceRule.TwoOwnerEnforcement &&
        !props.ownedResource.compliance[index].isCompliant
      ) {
        twoOwnerEnformentCompliant = false;
      }

      /*if (props.ownedResource.compliance[index].complianceRule === ComplianceRule.LeaseExpiration) {
        remainingDays = props.ownedResource.compliance[index].remainingLeaseDays;
      }*/
    }
    return !twoOwnerEnformentCompliant;
  }
  function openDepartmentEditorModal(
    departmentCode: string,
    isM365: boolean,
    resourceId: string,
    resourceName: string,
  ) {
    setDepartmentState((prev) => ({
      ...prev,
      departmentCode,
      resourceId,
      isM365,
      resourceName,
    }));
    showModal();
  }
  return (
    <div>
      <Modal isOpen={isModalOpen} onDismiss={hideModal} isBlocking={false}>
        <div className={contentStyles.header}>
          <h2 className={contentStyles.heading} id={titleId}>
            Worker department assigned to: <b>{departmentState.resourceName}</b>
            :
          </h2>
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={hideModal}
          />
        </div>
        <div className={contentStyles.body}>
          <DepartmentSelector
            departmentCode={departmentState.departmentCode}
            isM365={departmentState.isM365}
            resourceId={departmentState.resourceId}
            updateFunction={updateDepartment}
            defaultDepartmentList={defaultDepartmentList}
          ></DepartmentSelector>
        </div>
      </Modal>
      <div
        style={{
          display: props.ownedResources.length === 0 ? "inline" : "none",
        }}
        onScroll={handleTableScroll}
      >
        <div className="alert alert-light" role="alert">
          <h4 className="alert-heading">No resources to show</h4>
          <p></p>
          <hr />
          <p className="mb-0">
            You don't own any resource of this type at the moment. However, you
            have the option to use the{" "}
            <a
              target="_blank"
              href="https://apps.powerapps.com/play/e/c57452c8-1d59-4cc7-bb06-dd1bd68f06bf/a/44b067d3-ed7a-4b63-8933-c48670ed9a14?tenantId=46c98d88-e344-4ed4-8496-4ed7712e255d"
              rel="noreferrer"
            >
              setup tool
            </a>{" "}
            to create a new collaboration space.
          </p>
        </div>
      </div>
      <table
        className="accordion table table-responsive"
        style={{
          display: props.ownedResources.length > 0 ? "inline-table" : "none",
          width: "100%",
          maxHeight: "600px",
          overflowY: "auto",
        }}
      >
        <thead
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "white",
            transition: "box-shadow 0.3s ease", // smooth transition
            boxShadow: isScrolled
              ? "0 2px 2px -1px rgba(0, 0, 0, 0.2)"
              : "none",
          }}
        >
          <tr style={{ textAlign: "justify" }}>
            <th scope="col"></th>
            <th scope="col">
              <TooltipHost
                content="Name of the SharePoint site, Teams or Viva Engage community"
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Workspace Name
              </TooltipHost>
            </th>
            <th scope="col">
              <TooltipHost
                content="The department or subdivision linked to the workspace"
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Business Unit
              </TooltipHost>
            </th>
            <th scope="col">
              <TooltipHost
                content="Sensitivity labels let you classify and protect your organization's data, while making sure that user productivity and their ability to collaborate isn't hindered."
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Sensitivity Label
              </TooltipHost>
            </th>
            <th scope="col">
              <TooltipHost
                content="Type of workspace: Teams, SharePoint site, or Viva Engage community"
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Workspace Type
              </TooltipHost>
            </th>
            <th scope="col">
              <TooltipHost
                content="Current compliance status of the workspace"
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Status
              </TooltipHost>
            </th>
            <th scope="col">
              <TooltipHost
                content="When the workspace lease is going to expire"
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Expiration Date
              </TooltipHost>
            </th>
            <th scope="col">
              <TooltipHost
                content="Available actions for managing this workspace"
                style={{
                  display: "contents",
                  margin: 0,
                  padding: 0,
                  border: "none",
                  background: "transparent",
                  font: "inherit",
                  color: "inherit",
                }}
              >
                Actions
              </TooltipHost>
            </th>
          </tr>
        </thead>
        {props.ownedResources?.map((resource, i) => {
          return (
            <tbody
              id={"tbl-resource" + props.resourceType + i}
              key={"tbl-resource" + props.resourceType + i}
            >
              <tr style={{ textAlign: "justify" }}>
                <td>
                  <button
                    id={"btn-expandResource" + props.resourceType + i}
                    title="Display additional information about this resource"
                    className="accordion-button accordion-button-plusminus collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={"#resource-row" + props.resourceType + i}
                    data-resourceid={
                      resource.isGroupConnected
                        ? resource.azureAdId
                        : resource.siteId
                    }
                    data-isconnected={resource.isGroupConnected ? true : false}
                    style={{ padding: "0px", margin: "0px" }}
                    onClick={(targetButton) =>
                      handleResourceDetailLoad(
                        targetButton.currentTarget.id,
                        "resourceDetailContainer-" + props.resourceType + i,
                        resource,
                        i,
                      )
                    }
                  ></button>
                </td>
                <td>
                  <div
                    style={{
                      paddingTop: "3px",
                      margin: "auto",
                      textAlign: "justify",
                    }}
                  >
                    {resource.displayName !== ""
                      ? resource.displayName
                      : resource.siteUrl}{" "}
                    {resource.setupToolFlag !== "" ? (
                      <TooltipHost
                        tooltipProps={getExtClassificationToolTip(
                          resource.setupToolFlag,
                        )}
                        delay={TooltipDelay.zero}
                        directionalHint={DirectionalHint.bottomCenter}
                        styles={hostStyles}
                      >
                        <span className="badge rounded-pill bg-primary">
                          {resource.setupToolFlag}
                        </span>
                      </TooltipHost>
                    ) : (
                      ""
                    )}
                  </div>
                </td>
                <td>
                  <div style={{ paddingTop: "3px" }}>
                    {" "}
                    <TooltipHost
                      tooltipProps={departmenTtooltipProps}
                      delay={TooltipDelay.zero}
                      directionalHint={DirectionalHint.bottomAutoEdge}
                      styles={hostStyles}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          openDepartmentEditorModal(
                            resource.departmentCd,
                            resource.isGroupConnected,
                            resource.isGroupConnected
                              ? resource.azureAdId
                              : resource.siteId,
                            resource.displayName,
                          );
                        }}
                      >
                        <button
                          className="btn shadow-none"
                          style={{
                            fontSize: "14px",
                            overflow: "hidden",
                            paddingLeft: "0px",
                            paddingRight: "0px",
                          }}
                        >
                          {resource.departmentNm}{" "}
                          <FontIcon aria-label="Compass" iconName="Edit" />
                        </button>
                      </div>
                    </TooltipHost>
                  </div>
                </td>
                <td>
                  <div style={{ paddingTop: "3px" }}>
                    <TooltipHost content="Sensitivity labels let you classify and protect your organization's data, while making sure that user productivity and their ability to collaborate isn't hindered.">
                      {resource.sensitivityLabel === ""
                        ? "Not Set"
                        : resource.sensitivityLabel}
                    </TooltipHost>
                  </div>
                </td>
                <td>
                  <ResourceNavlink
                    resourceType={resource.resourceType}
                    resourceUrl={getResourceLink(resource)}
                  />
                </td>
                <td>
                  <ComplianceField
                    complianceResults={resource.compliance}
                  ></ComplianceField>
                </td>
                <td>
                  <ExpirationDateField
                    lastActivityDate={resource.lastUpdatedFormatted}
                    complianceResults={resource.compliance}
                    formatedComplianceDate={getFormattedDate(
                      resource.renewDateFormatted,
                      false,
                    )}
                    sensitivityLabel={resource.sensitivityLabel}
                    setupToolFlag={resource.setupToolFlag}
                  />
                </td>
                <td>
                  {/**  <TooltipHost
                    tooltipProps={getDeleteButtonTooltip(resource.agsTracked)}
                    delay={TooltipDelay.zero}
                    directionalHint={DirectionalHint.bottomCenter}
                    styles={hostStyles}
                  >*/}
                  {/* <button
                      type="button"
                      className="btn btn-danger me-1"
                      onClick={async () => {
                        await redirectoDeletePage(resource, i);
                      }}
                    >
                      Delete
                    </button>
                     */}
                  <CommandBar
                    style={{ padding: "0px" }}
                    overflowButtonProps={overflowProps}
                    items={[]}
                    overflowItems={[
                      {
                        key: "rename",
                        onClick: () => {
                          encourageArchive(
                            {
                              ownedResource: resource,
                              baseTabId: "tab-" + props.resourceType + i,
                              refreshDatasetFunction:
                                props.refreshDatasetFunction,
                            },
                            i,
                            props.resourceType,
                          );
                        },
                        text: calculateCompliance({
                          ownedResource: resource,
                          baseTabId: "tab-" + props.resourceType + i,
                          refreshDatasetFunction: props.refreshDatasetFunction,
                        })
                          ? "Add backup owner first"
                          : "Renew",
                        iconProps: {
                          iconName: calculateCompliance({
                            ownedResource: resource,
                            baseTabId: "tab-" + props.resourceType + i,
                            refreshDatasetFunction:
                              props.refreshDatasetFunction,
                          })
                            ? "Error"
                            : "Edit",
                        },
                        disabled: calculateCompliance({
                          ownedResource: resource,
                          baseTabId: "tab-" + props.resourceType + i,
                          refreshDatasetFunction: props.refreshDatasetFunction,
                        }),
                      },
                      {
                        key: "Permissions",
                        text: "Site Permissions",
                        onClick: () => {
                          requestPermissionsReport(resource);
                        },
                        iconProps: { iconName: "Permissions" },
                      },
                      {
                        key: "delete",
                        text: "Delete",
                        onClick: () => {
                          redirectoDeletePage(resource, i);
                        },
                        iconProps: { iconName: "Delete" },
                      },
                      {
                        key: "Archive",
                        text: "Archive",
                        onClick: () => {
                          ArchiveResources(resource);
                        },
                        iconProps: { iconName: "Archive" },
                      },
                    ]}
                    styles={{
                      root: {
                        padding: 0,
                        color: "#0054ae",
                      },
                    }}
                  />
                  {/* </TooltipHost>*/}
                </td>
              </tr>
              <tr
                data-bs-parent=".table"
                style={{ borderColor: "transparent" }}
              >
                <td colSpan={8} style={{ padding: "0px" }}>
                  <div
                    id={"resource-row" + props.resourceType + i}
                    className="collapse"
                    data-bs-parent=".table"
                  >
                    <div className="accordion-body" style={{ padding: "0" }}>
                      <br />
                      <div
                        id={"resourceDetailContainer-" + props.resourceType + i}
                      ></div>
                      <br />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          );
        })}
      </table>
    </div>
  );
}
